import Error from "next/error";
import Head from "next/head";
import { graphql, useLazyLoadQuery } from "react-relay";

import { CollectionDetailsPageQuery } from "../../__generated__/CollectionDetailsPageQuery.graphql";
import { generateTitle } from "../../lib/utils/title";
import ItemList from "../item/listing/ItemList";
import Container from "../layout/Container";
import Main from "../layout/Main";

type CollectionDetailsPageProps = {
  slug: string;
};

const query = graphql`
  query CollectionDetailsPageQuery($slug: String!) {
    collection(slug: $slug) {
      title
      ...ItemList
    }
  }
`;

function CollectionDetailsPage(props: CollectionDetailsPageProps) {
  const { collection } = useLazyLoadQuery<CollectionDetailsPageQuery>(query, {
    slug: props.slug,
  });

  if (!collection) {
    return <Error statusCode={404} />;
  }

  const title = generateTitle(collection.title);

  return (
    <Main>
      <Head>
        <title>{title}</title>
      </Head>

      <Container className="py-16">
        {collection.title && (
          <h2 className="text-xl font-bold text-gray-900">
            {collection.title}
          </h2>
        )}

        <ItemList className="mt-8" root={collection} />
      </Container>
    </Main>
  );
}

CollectionDetailsPage.query = query;

export default CollectionDetailsPage;
